<template>
    <div id="app">
        <router-view :initialized="initialized"/>
    </div>
</template>

<script>
import ServerApi from "@/js/ServerApi";

ServerApi.setEndpoint('https://api.ruurd.dev');
// ServerApi.setEndpoint('http://localhost:3000');


export default {
    name: 'app',
    data() {
        return {
            initialized: false,
            routeHistory: [],
        }
    },
    async mounted() {
        console.log("Version 0.1")
        if (localStorage.getItem('auth') === null && !this.$route.path.includes('/login')) {
            await this.$router.push('/login');
        } else if (localStorage.getItem('auth') !== null) {
            let auth = JSON.parse(localStorage.auth);
            console.log(auth)
            await ServerApi.auth(auth.email, auth.password);
            this.initialized = true;
        }
    },
    watch: {
        $route() {
            console.log(this.routeHistory);
            if (this.routeHistory.length > 0) {
                let lastRoute = this.routeHistory[this.routeHistory.length - 1];
                if (lastRoute.includes('login'))
                    this.$router.go();
            }
            this.routeHistory.push(this.$route.path);
        }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Material+Icons|Montserrat|Roboto:400,400i,500,700&display=swap');

#app {
    font-family: 'Montserrat', 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
